import GenericErrorCodes from "../../../errorCodes/Generic"

export type errorHandlerCallback = (errorCode: string, error?: PBError) => string

const handlers: errorHandlerCallback[] = [genericErrorHandler]

class ErrorHandlerRegister {
  add(handler: errorHandlerCallback) {
    // make sure we don't add the same handler more than once
    if (!handlers.includes(handler) && typeof handler === "function") {
      handlers.push(handler)
    }
  }

  remove() {
    throw new Error("[ErrorHandlerRegister]: Not yet implemented.")
  }

  getMessage(errorCode: string, error?: PBError | GraphError) {
    let message = "errors.unknownError"
    handlers.forEach((handler) => {
      const msg = handler(errorCode, error)
      if (msg) {
        message = msg
      }
    })

    return message
  }
}

export default new ErrorHandlerRegister()

function genericErrorHandler(errCode: string) {
  switch (errCode) {
    case GenericErrorCodes.PBERRForbiddenNoPermission:
    case GenericErrorCodes.PBERRForbiddenRestrictionCheckFailed:
      return "errors.PBERRForbiddenNoPermission"
    case GenericErrorCodes.PBERRForbiddenInvalidToken:
    case GenericErrorCodes.PBERRTokenMissing:
      return "errors.PBERRForbiddenInvalidToken"
    default:
      return ""
  }
}
